import React from 'react';
import { NavLink } from 'react-router-dom';

function UserAccessNav() {
  return (
    <div className="sub-tabs flex flex-wrap gap-4 px-6 pt-2 pb-4">
      <NavLink to="/userAccessEvents" className={({ isActive }) => `link sub-tab ${isActive ? 'font-bold' : ''}`}>
        Prístupy
      </NavLink>
      <NavLink to="/userAccessUsers" className={({ isActive }) => `link sub-tab ${isActive ? 'font-bold' : ''}`}>
        Používatelia
      </NavLink>
      <NavLink to="/userAccessNotifications" className={({ isActive }) => `link sub-tab ${isActive ? 'font-bold' : ''}`}>
        Notifikácie
      </NavLink>
    </div>
  );
}

export default UserAccessNav;
